import {useInstance} from 'react-ioc';
import {Link} from 'react-router-dom';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Space} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {toProductId} from '../../../config/routes';
import {Store} from '../../../model/store/Store';
import {CurrencyFormat} from '../../../shared/helpers/CurrencyFormat';
import {fullUrl} from '../../../shared/helpers/fullUrl';

import {Tag} from './Tag';

import cls from './Category.module.scss'

interface AromaItem {
    documentId: string
    name: string
}

interface Props {
    id: string
    name: string
    tag_hit: boolean
    tag_new: boolean
    tag_pre_order: boolean
    volume?: number
    price: number
    cover: string
    aromas?: (AromaItem | null)[] | null
}

export const Card = observer(({id, cover, name, volume, price, tag_hit, tag_new, tag_pre_order, aromas}: Props) => {

    const {order} = useInstance(Store)

    const aromasCount = aromas?.length ?? 0
    const singleAromaId = aromasCount === 1 && aromas?.[0] ? aromas[0].documentId : undefined
    const singleAromaName = aromasCount === 1 && aromas?.[0] ? aromas[0].name : undefined

    const current = _.find(
        order.positions,
        (p) => p.documentId === id && (p.aromaDocumentId ?? '') === (singleAromaId ?? '')
    )

    const addToCart = () => {
        order.addPosition(id, cover, name, price, singleAromaId, singleAromaName)
    }

    const plus = () => order.plusQuantity(id, singleAromaId)
    const minus = () => order.minusQuantity(id, singleAromaId)

    const showQuantityControls = aromasCount <= 1

    return (
        <div className={cls.card}>
            <Link to={toProductId(id)} className={cls.link}>
                <div className={cls.cover} style={{backgroundImage: `url(${fullUrl(cover)})`}}/>
                {(tag_hit || tag_new || tag_pre_order) && <div className={cls.tags}>
                    {tag_hit && <Tag type={'hit'}/>}
                    {tag_new && <Tag type={'new'}/>}
                    {tag_pre_order && <Tag type={'pre_order'}/>}
                </div>}
                <h3>{name}</h3>
                {volume && <div>{volume}</div>}
            </Link>
            <div className={cls.line}>
                <div className={cls.price}>{CurrencyFormat(price)} ₽</div>
                <div>
                    {showQuantityControls ? (
                        current && current.quantity > 0 ?
                            <Space size={16}>
                                <Button type={'primary'} onClick={minus} icon={<MinusOutlined/>} shape={'circle'}/>
                                <span>{current?.quantity} шт.</span>
                                <Button type={'primary'} onClick={plus} icon={<PlusOutlined/>} shape={'circle'}/>
                            </Space>
                            :
                            <Button type={'primary'} onClick={addToCart}>В корзину</Button>
                    ) : (
                        <Link to={toProductId(id)}><Button type={'primary'}>Подробнее</Button></Link>
                    )}
                </div>
            </div>
        </div>
    )
})